// extracted by mini-css-extract-plugin
export default {"container":"TitleWithSplit_container__k0K9h","splitter":"TitleWithSplit_splitter__9MW3U","title":"TitleWithSplit_title__nH5qV"};